// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f5ecc189","845":"5f71feba"}[chunkId] + ".chunk.js";
};